<template>
    <div>
        <nav class="main-nav">
            <a class="logo" href="/">
                <img src="../../assets/logo.png">
            </a>
            <burger></burger>
        </nav>

        <a href="https://www.instagram.com/de_belgische_mastiff/" target="_blank" id="IG">
          <instagram class="icon-large" @mouseover="changeFillColor"></instagram>
        </a>

        <Sidebar>
            <ul class="sidebar-panel-nav" @click="closeNavbar">
                <li><router-link to="/" class="logo-menu">
                    <img src="../../assets/logo_reverse.png">
                </router-link></li>
                <!-- <li><a href="#news">nieuws</a></li> -->
                <li><a href="#about">over ons</a></li>
                <li><a href="#media">media</a></li>
                <li><a href="#puppy">puppy</a></li>
                <li><a href="#history">geschiedenis</a></li>
                <li><a href="#contact">contact</a></li>
            </ul>
        </Sidebar>

        <div id="intro" class="columns is-centered">
            <div class="column intro is-three-fifths">
                <intro></intro>
            </div>
        </div>
        <div id="carousel" class="columns is-centered">
            <div class="column is-three-fifths has-next-page">
                <carousel></carousel>
            </div>
        </div>
        <!-- <div id="news" class="columns is-centered">
            <div class="column is-three-fifths has-next-page">
                <news></news>
            </div>
        </div> -->
        <div id="about" class="columns is-centered">
            <div class="column is-three-fifths">
                <about></about>
            </div>
        </div>
        <div id="gallery" class="columns is-centered">
            <div class="column is-three-fifths has-next-page">
                <gallery></gallery>
            </div>
        </div>
        <div id="media" class="columns is-centered">
            <div class="column is-three-fifths has-next-page">
                <media></media>
            </div>
        </div>
        <div id="puppy" class="columns is-centered">
            <div class="column is-three-fifths has-next-page">
                <puppy></puppy>
            </div>
        </div>
        <div id="history" class="columns history is-centered">
            <div class="column is-three-fifths has-next-page">
                <history></history>
            </div>
        </div>
        <div id="contact" class="column contact is-centered">
            <contact></contact>
        </div>
        <div class="column footer">
            <div class="columns">
                <div class="column is-half">
                    <p class="copy">© 2019 De Belgische Mastiff vzw</p>
                </div>
<!--
                <div class="column is-half">
                    <a href="#" class="terms">Terms &amp; Conditions</a>
                </div>
-->
            </div>
        </div>

        <back-to-top bottom="2vw" right="2vw">
            <chev-up-icon class="icon-large"></chev-up-icon>
        </back-to-top>
    </div>
</template>
<script>
    import Burger from '../Menu/Burger';
    import Sidebar from '../Menu/Sidebar';
    import Intro from './Intro';
    import Carousel from './Carousel';
    // import News from './News';
    import About from './About';
    import Gallery from './Gallery';
    import History from './History';
    import Puppy from './Puppy';
    import Media from './Media';
    import Contact from './Contact';
    import { store } from '@/store.js';
    import BackToTop from 'vue-backtotop';
    import ChevUpIcon from 'vue-material-design-icons/ChevronUp.vue'
    import Instagram from 'vue-material-design-icons/Instagram.vue'

    export default {
        name: "Home",
        components: {
            Burger,
            Sidebar,
            Intro,
            Carousel,
            // News,
            About,
            Gallery,
            History,
            Puppy,
            Media,
            Contact,
            BackToTop,
            ChevUpIcon,
            Instagram
        },
        methods: {
          closeNavbar: function() {
            store.isNavOpen = false;
          },
          changeFillColor(e) {
            e.target.style.fill = "#489c9a"
            e.target.addEventListener('mouseout', () => e.target.style.fill = '', false)
          }
        }
    }
</script>

<style scoped>
    .intro {
        margin-top: 2vw;
        margin-bottom: 2vw;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .has-next-page {
        padding-bottom: 5vh;
    }

    .remove-lr-margins {
        margin-left: 0;
        margin-right: 0;
    }

    .columns.history {
        background: #f5f5ef;
        margin-bottom: 0;
        padding-top: 5vh;
        padding-bottom: 5vh;
    }

    .contact {
        padding-top: 10vh;
        background: #99C5C4;
    }

    .footer {
        margin: 0;
        padding: 1em;
        background-color: #99C5C4;
    }

    .copy {
        color: #006f70;
        font-weight: 300;
    }

    .terms {
        color: #006f70;
        font-weight: 300;
        position: absolute;
        right: 1vw;
        transition: color .3s ease;
    }

    .terms:hover {
        color: #fff;
    }

    .navbar-end a {
        color: #016F70;
        font-size: 1.1em;
        font-weight: 500;
        transition: color .3s ease, border .3s ease;
    }

    .navbar-end a:hover {
        color: #99C5C4;
        background-color: rgba(255, 255, 255, 0);
    }

    .material-design-icon {
        height: 2em;
        width: 2em;
    }
    .material-design-icon > .material-design-icon__svg {
        height: 2em;
        width: 2em;
        fill: #016F70;
    }
</style>

<style>
    html {
        height: 100%;
        /* overflow: hidden; */
    }

    ul.siderbar-panel-nav {
        list-style-type: none;
    }

    ul.sidebar-panel-nav>li>a {
        font-family: 'Poppins';
        color: #fff;
        text-decoration: none;
        font-size: 1.5rem;
        display: block;
        padding-bottom: 0.5em;
        transition: color .3s ease;
    }

    ul.sidebar-panel-nav>li>a:hover {
        color: #99C5C4;
    }

    ul.sidebar-panel-nav>li>a.logo-menu {
        transition: transform .6s cubic-bezier(.165,.84,.44,1);
    }

    .logo {
        z-index: 997;
        pointer-events: all;
        align-self: center;
        width: 128px;
        margin-top: 20px;
        transition: transform .6s cubic-bezier(.165,.84,.44,1);
    }

    .logo-menu {
        align-self: center;
        width: 128px;
        margin-top: 0px;
        transition: transform .6s cubic-bezier(.165,.84,.44,1);
    }

    .logo:hover {
        transform: scale(.93);
    }

    .logo-menu:hover {
        transform: scale(.93);
    }

    .main-nav {
        width: 100%;
        position: fixed;
        display: flex;
        pointer-events: none;
        justify-content: space-between;
        padding: 0.8rem 0.8rem;
    }

    #IG {
      z-index: 999;
      position: fixed;
      margin-right: 16px;
      display: block;
      right: 2vw;
      top: 100px;
    }

    instagram {
      transition: fill .3s ease;
    }

    #burger {
        z-index: 999;
    }

    #app {
        background-color: #fffffc;
    }

    .column.has-page-padding {
        padding: 3vh 5vh 5vh 5vh;
        background: #F5F5F5;
    }

    .is-page-title {
        color: #016F70;
        /* See SCSS */
        font-weight: bold;
        line-height: 2;
    }

    .is-page-content {
        color: #016F70;
    }

    .is-page-read-more {
        color: #016F70;
        background-color: #f5f5ef;
        padding: .5em 1em;
        font-size: 1.3em;
        text-align: center;
        margin-top: 2em;
        transition: color .3s ease, background-color .3s ease;
    }

    .is-page-read-more:hover {
        background-color: #016F70;
        color: #f5f5f5;
    }

    .is-page-read-more-history {
        color: #016F70;
        background-color: #eaeae5;
        padding: .5em 1em;
        font-size: 1.3em;
        text-align: center;
        margin-top: 3em;
        transition: color .3s ease, background-color .3s ease;
    }

    .is-page-read-more-history:hover {
        background-color: #016F70;
        color: #f5f5f5;
    }

    .is-news-read-more {
        position: relative;
        color: #016F70;
        font-size: 1.1em;
        font-weight: 500;
        /*        border-bottom: 2px solid #016F70;*/
        padding-bottom: 2px;
        transition: color .3s ease, border .3s ease;
    }

    .is-news-read-more:before {
        content: "";
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        left: 0;
        background-color: #016F70;
        visibility: hidden;
        transition: all 0.3s ease-in-out;
    }

    .is-news-read-more:hover:before {
        visibility: visible;
        width: 100%;
    }

    .is-news-read-more:hover {
        /*        border-bottom: 2px solid #99C5C5;*/
        color: #016F70;
    }

    .more-button {
        background: #f5f5f5;
        padding: 10px 25px;
    }

    p {
        font-weight: 400;
        text-align: left;
        text-justify: inter-word;
    }

    @media screen and (min-width: 1024px) {
        .logo, .logo-menu {
            width: 148px;
        }
        .main-nav {
            padding: 2vw 2vw;
        }
        #IG {
          top: 80px;
        }
    }

    @media screen and (min-width: 1300px) {
        .logo, .logo-menu {
            width: 168px;
        }
        .main-nav {
            padding: 2vw 2vw;
        }
        #IG {
          top: 100px;
        }
    }

    @media screen and (max-width: 1024px) {
      #IG {
        margin-right: 16px;
        right: 1.5vw;
        top: 60px;
      }
    }

    @media screen and (max-width: 768px) {
        #news, #about, #gallery, #puppy, #history, #page-content, #contact, #media {
            padding-left: 10%;
            padding-right: 10%;
        }
        #intro {
            padding-left: 5%;
            padding-right: 5%;
            text-align: center;
        }
        .main-nav {
            position: relative;
        }
        .logo, .logo-menu {
            margin: 20px auto 0px auto;
        }
        ul.sidebar-panel-nav>li>a {
            text-align: center;
        }
        ul.sidebar-panel-nav>li:first-child {
            margin-bottom: 25px;
        }
        #burger {
            position: fixed;
            right: 2vw;
        }
        .burger-button {
            margin-right: 0px;
            margin-top: 0px;
        }
        #IG {
          margin-right: 16px;
          right: .8vw;
          top: 70px;
        }
        .contact {
            padding-top: 10vw;
            margin-top: 0;
        }
        .copy {
            text-align: center;
        }
        .control-left, .control-right {
            display: none !important;
        }
    }

    @media screen and (max-width: 480px) {
      #IG {
        top: 60px;
        right: 0vw;
        margin-right: 13px;
      }
    }
</style>
